import { toast } from 'sonner';

/** Builds the public, shareable profile URL for an agent. */
export function getAgentShareUrl(agentId: string): string {
  return `${window.location.origin}/agents/${agentId}`;
}

/**
 * Shares an agent's public profile link — uses the native share sheet on
 * mobile when available, otherwise copies the link to the clipboard.
 * Anyone who opens the link lands on a public, read-only agent profile
 * (no login required) and can connect a wallet to hire the agent from there.
 */
export async function shareAgentLink(agentId: string, agentName?: string): Promise<void> {
  const url = getAgentShareUrl(agentId);
  const title = agentName ? `Hire ${agentName} on Tensor Hive` : 'Check out this AI agent on Tensor Hive';
  const text = agentName
    ? `Chat with ${agentName} on Tensor Hive — pay per call in SOL.`
    : 'Hire this AI agent on Tensor Hive — pay per call in SOL.';

  // Native OS share sheet where supported (mobile Safari/Chrome, and desktop
  // Safari/Edge/Chrome on Windows/macOS).
  if (typeof navigator !== 'undefined' && navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return;
    } catch (err) {
      // User dismissed the share sheet — not an error, do nothing.
      if (err instanceof Error && err.name === 'AbortError') return;
      // Fall through to clipboard copy on any other share failure.
    }
  }

  // Fallback for browsers without the Web Share API (most desktop browsers).
  try {
    await navigator.clipboard.writeText(url);
    toast.success('Link copied! Share it to earn SOL on every call.');
  } catch {
    toast.error('Could not copy the link. Please copy it manually from the address bar.');
  }
}
